<template>
  <div class="root">
    <input
      v-bind="$attrs"
      :ref="`${name}-input`"
      v-on="$listeners"
      class="b-input"
      :name="name"
      :value="value"
      @input="$emit('update', $event.target.value)"
      @change="onChange"
    />
    <span class="b-error-message" v-if="error">{{ error }}</span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: false,
    },
    value: {
      type: String
    },
  },
  model: {
    prop: "value",
    event: "update",
  },
  methods: {
    onChange(event) {
      // Supports .lazy
      // Can add validation here
      this.$emit("change", event.target.value);
    },
  },
};
</script>

<style scoped>
.root {
  position: relative;
  width: -webkit-fill-available;
}
.b-input {
  border: solid 1px #dadada;
  background: white;
  width: -webkit-fill-available;
}

.b-input[disabled] {
  background-color: #f4f4f4;
}

.b-input:hover {
  border-width: 1px;
  border-color: #b6b6b6;
}
.b-input:focus-visible {
  outline: none;
  border: solid 1px #4e63ff;
}

/* Chrome, Safari, Edge, Opera */
input.b-input::-webkit-outer-spin-button,
input.b-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input.b-input[type="number"] {
  -moz-appearance: textfield;
}

.b-error-message {
  position: absolute;
  right: 5px;
  top: 3px;
  margin: 0;
  font-style: oblique;
  color: #ff0505;
  margin-right: 16px;
  font-size: 1.5rem;
}
</style>
